import serialNumberSelection from './serialNumberSelection.vue'
export default serialNumberSelection
